import {
  AUCTION_STATUS_IN_PROGRESS,
  PREDICAMENT_STATE_NO,
  PREDICAMENT_STATE_YES,
  SEARCH_TYPE_CARE,
} from "core/consts";
import { Auction, DeepNullableObj } from "core/types";
import { getUnixTime } from "date-fns";
import { defaultsDeep } from "lodash";
import { MockFn, createMock } from "./index";
import mockCareprovider from "./mockCareprovider";
const start_date = getUnixTime(new Date(2021, 10, 1));

const mockAuction: MockFn<Partial<DeepNullableObj<Auction>>> = (args) =>
  defaultsDeep(
    args,
    createMock(
      "Auction",
      args,
      (shallow): DeepNullableObj<Auction> => ({
        __typename: "Auction",
        action_required_by_user: false,
        additional_specializations: null,
        admissions: {
          admission_form_id: null,
          agreed_at: null,
          profile: {
            care_frequency: null,
            care_frequency_other: null,
            current_care_facility_other: null,
            current_care_facility_types: null,
            current_care_types: null,
            has_infection: null,
            insurance_other: null,
            insurance_type: null,
            is_patient_main_contact: null,
            main_contact_first_name: null,
            main_contact_last_name: null,
            main_contact_phone: null,
            mental_ability: null,
            mobility: null,
            preexisting_conditions: null,
            referral_sources: null,
            referral_sources_other: null,
            relationship_other: null,
            relationship_to_patient: null,
            required_care_basic_types: null,
            required_care_other: null,
            required_care_types: null,
            search_reason: null,
            search_reason_other: null,
            special_care_needs: null,
            special_care_needs_other: null,
            visit_times: null,
            visit_times_other: null,
          },
          step: null,
        },
        all_contacted: null,
        all_negative: null,
        assessment_completed: true,
        assessment_variant: null,
        cancel_auction: {
          description: null,
          reason: null,
        },
        cancel_validation_reason: null,
        candidates_status: null,
        country_wide_search: false,
        created_at: null,
        id: 1,
        is_stale: false,
        last_status_change: null,
        max_accepts: null,
        medical_supplies: {
          additional_information: null,
          delivery_address: {
            city: null,
            encrypted_house_number: null,
            floor: null,
            latitude: null,
            longitude: null,
            radius_in_meter: null,
            street: null,
            zipcode: null,
          },
          delivery_address_type: null,
          prescription_issued: null,
          prescription_issued_description: null,
          products: [],
        },
        new_responses: 0,
        patient: null,
        patient_id: null,
        payers: {
          civil_servants_aid: null,
          free_from_supplementary_payment_state: PREDICAMENT_STATE_YES,
          further_information: null,
          insurance: {
            config: {
              use_vzd_kim_address: null,
            },
            id: 1,
            name: "Test Insurance",
          },
          other_payer: null,
          public_accident_insurance: null,
          public_pension: null,
          selected_payment_method: null,
          self_payer: null,
          social_service_department: null,
          supplementary_insurance: null,
          supplementary_insurance_state: PREDICAMENT_STATE_YES,
          supplementary_payment: null,
          supplementary_payment_state: PREDICAMENT_STATE_YES,
        },
        pending_requests: null,
        profile: {
          has_transitional_care: null,
          is_elective: false,
          is_visually_impaired: PREDICAMENT_STATE_NO,
          monitoring_needs: null,
          needs_oxygen: null,
          no_site_support_required: true,
          patient_type_updated: null,
          pick_up: { end: null, start: null },
          search_destination: {
            city: null,
            country: null,
            encrypted_house_number: {
              content: null,
              decrypted: null,
              iv: null,
              seald_content: null,
            },
            federal_state: null,
            floor: null,
            latitude: null,
            longitude: null,
            radius_in_meter: null,
            street: null,
            zipcode: null,
          },
          search_location: {
            city: "Berlin",
            encrypted_house_number: {
              content: "",
              decrypted: "103",
              iv: "",
              seald_content: "",
            },
            federal_state: null,
            floor: null,
            latitude: 52.5237568,
            longitude: 13.3801421,
            radius_in_meter: 100,
            street: "Alt-Moabit",
            zipcode: "10559",
          },
        },
        radius_in_meter: null,
        request_count: null,
        seald_encryption_context: {
          auction_request_id: null,
          careprovider_id: null,
          careseeker_id: null,
          file_id: null,
          id: null,
          patient_id: null,
          seald_display_id: null,
          seald_id: null,
          seald_type: null,
        },
        search_actions: args?.search_actions
          ? args?.search_actions.map((searchAction) => ({
              action_type: searchAction?.action_type || null,
              context: {
                disabled: searchAction?.context?.disabled || null,
                variant: searchAction?.context?.variant || null,
              },
            }))
          : null,
        search_type: SEARCH_TYPE_CARE,
        seen_by_user: null,
        services: null,
        session_key_context: {
          has_session_keys: false,
          session_key: {
            account_id: 1,
            algorithm: null,
            auction_request_id: 1,
            careprovider_id: 1,
            careseeker_id: 1,
            id: 1,
            patient_id: 1,
            session_key: null,
            updated_at: 1,
          },
        },
        share_patient_data_automatically: false,
        solutions: [],
        specializations: [],
        start_date: start_date,
        start_date_flexible: false,
        status: AUCTION_STATUS_IN_PROGRESS,
        winner: {
          auction_request_id: null,
          careprovider: mockCareprovider({ ...shallow("Careprovider"), id: 6 }),
          careprovider_name: null,
          created_at: null,
          external_provider: null,
          solution: null,
          specialization: null,
          unknown_provider: null,
          updated_at: null,
        },
      }),
    ),
  );

export default mockAuction;
